import React from 'react';
import './ServicesSection.css';

const ServicesSection = () => {
  const services = [
    {
      title: 'E-commerce Solutions',
      headline: 'Boost online sales with smart e-commerce',
      features: [
        'Product catalogs with unlimited items',
        'Shopping cart & secure checkout',
        'Inventory management',
        'Order tracking & notifications'
      ],
      icon: 'fas fa-shopping-cart'
    },
    {
      title: 'Food & Restaurants',
      headline: 'Streamline orders and delight customers',
      features: [
        'Online menu & ordering system',
        'Table reservation management',
        'Delivery & pickup integration',
        'Kitchen order tracking'
      ],
      icon: 'fas fa-utensils'
    },
    {
      title: 'Healthcare Portals',
      headline: 'Secure patient care & practice management',
      features: [
        'Appointment scheduling',
        'Patient records management',
        'Teleconsultation platform',
        'HIPAA-compliant security'
      ],
      icon: 'fas fa-clinic-medical'
    },
    {
      title: 'Professional Services',
      headline: 'Attract clients and manage projects',
      features: [
        'Service showcase portfolio',
        'Client portal & dashboard',
        'Project tracking system',
        'Automated invoicing'
      ],
      icon: 'fas fa-briefcase'
    }
  ];

  return (
    <section className="home-services-section" id="serv">
      <div className="container">
        <h2 className="home-section-title">Industry-Specific Solutions</h2>
        <p className="home-section-subtitle">Purpose-built templates for your business type</p>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="card service-card-inner">
                <div className="service-icon">
                  <i className={service.icon}></i>
                </div>
                <h3 className="card-title">{service.title}</h3>
                <h4 className="service-headline">{service.headline}</h4>
                <ul className="service-features">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>
                      <i className="fas fa-check"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;